import api from '@/lib/api';

export interface MyReviewReply {
  text: string;
  repliedAt: string;
  updatedAt: string;
}

export interface MyReview {
  id: string;
  authorName: string;
  rating: number;
  feedback: string | null;
  createdAt: string;
  reply: MyReviewReply | null;
  canReply: boolean;
}

export interface MyReviewsResponse {
  reviews: MyReview[];
  pagination: { page: number; limit: number; total: number; hasMore: boolean };
}

export async function getMyReviews(page = 1, limit = 10): Promise<MyReviewsResponse> {
  const res = await api.get<{ data: MyReviewsResponse }>('/professionals/me/reviews', {
    params: { page, limit },
  });
  return res.data.data;
}

export async function replyToReview(callSessionId: string, text: string): Promise<MyReview> {
  const res = await api.put<{ data: MyReview }>(
    `/professionals/me/reviews/${callSessionId}/reply`,
    { text }
  );
  return res.data.data;
}

export async function deleteReviewReply(callSessionId: string): Promise<MyReview> {
  const res = await api.delete<{ data: MyReview }>(
    `/professionals/me/reviews/${callSessionId}/reply`
  );
  return res.data.data;
}
